module.exports = __webpack_public_path__ + "static/drapery-hardware-dfcd14037446cec3ddbe92ef611ae910.png";